<template>
  <div class="content animate-route">
    <!-- 走马灯 -->
    <a-row style="background-color: #1f1f1f">
      <a-col :xs="0" :sm="24">
        <a-carousel autoplay>
          <div v-for="item in advList3" :key="item.id" class="adv">
            <!-- 判断是否有图片外链 -->
            <!-- 有链接 -->
            <a :href="item.advertisingUrl" target="_blank" v-if="item.advertisingUrl">
              <img :src="imgUrl + item.advertisingImg" />
            </a>
            <!-- 无连接仅显示图片 -->
            <img :src="imgUrl + item.advertisingImg" v-else />
          </div>
        </a-carousel>
      </a-col>
    </a-row>
    <!-- 视频控制 -->
    <div class="nav">
      <a-row class="control" slot="nav" type="flex" align="middle" justify="space-between">
        <a-col :span="6"><span class="title">播放</span></a-col>
        <a-col :span="6">
          <span class="play" @click="onDialogShow">
            <play theme="outline" size="66" fill="#efefef" :strokeWidth="1" />
          </span>
        </a-col>
        <a-col :span="6"><span class="title">视频</span></a-col>
      </a-row>
    </div>
    <!-- 锯齿边平铺 -->
    <div class="split"></div>
    <!-- 文字轮播 -->
    <a-row class="text-carousel">
      <a-col class="title" :span="24">
        <ul class="text">
          <li><img src="~@/assets/images/cleaf_home_logo.png" /></li>
          <li :class="carousel === 0 ? 'active' : ''">意大利制造</li>
          <li :class="carousel === 1 ? 'active' : ''">工艺技术</li>
          <li :class="carousel === 2 ? 'active' : ''">产品研发</li>
          <li :class="carousel === 3 ? 'active' : ''">工业设计奖</li>
        </ul>
      </a-col>
      <a-col :span="24">
        <a-carousel :beforeChange="carouselChange" class="carousel" autoplay>
          <div class="text">
            <p>
              Cleaf的目标是在材料表面上将感知触觉和审美视觉有机和谐为一体，为家具，厨卫行业持续提供高品质和创造性的饰面材料。因此，Cleaf为客户提供了一套体现品质追求及高性价比的材料解决方案。
            </p>
            <p>
              Cleaf工厂位于Brianza,
              该地区为世界一流高端家具，厨卫品牌云集的地区。Cleaf通过为这些高端家具、厨卫品牌订制材料与产品，充分展现了意大利的设计理念，工艺制造水平，及未来行业流行的发展趋势。因此某种程度上，Cleaf制造，代表了意大利制造。
            </p>
          </div>
          <div class="text">
            <p>40年的订制生产经验，Cleaf已成为一家可以综合提供室内装修饰面材料及了解行业领先加工工艺的专业生产厂家。</p>
            <p>
              Cleaf的工艺技术核心体现在世界领先的板材压贴技术。公司采用世界领先的压贴生产设备，独立研发设计的钢板，高精度的裁切，封边处理，以及大型CNC加工中心，可提供室内装修领域的整体材料供应，以及材料加工后半成品的供应。
            </p>
            <p>同时Cleaf高度关注环境保护。公司产品通过全球森林环保认证。</p>
          </div>
          <div class="text">
            <p>
              Cleaf研发试验室的产品研发，不仅是材料表面的设计研发，同时充分结合了意大利建筑设计师们的原创设计理念和对新工艺技术的实践。Cleaf产品逐年荣获"红点"工业设计奖。
            </p>
            <p>
              经过技术研究和探索，将自然界，室内设计，建筑，生活时尚等不同领域的时尚元素通过高科技技术处理，真实还原再现到板材表面上。
            </p>
            <p>
              Cleaf板材的表面处理充分展现了设计的审美视觉和良好感知触觉。材料在运用后，体现家具产品高品质的审美诉求。
            </p>
          </div>
          <div class="text">
            <p>
              Cleaf在三聚氰胺压贴饰面领域的领先被全球所认可，逐年荣获各类国际奖项。<br />
              – INTERZUM 2019红点工业智能材料和设计奖<br />
              – 2020 ADI Compasso d'Oro Award（意大利黄金罗盘奖）<br />
              – 自2009年逐年荣获：红点工业设计杰出材料奖<br />
              Mosaico 获得了"Interzum 2019
              红点工业智能材料和设计奖"。它的表面纹理是方格编织的组合，其不规则的外观由不同的深度和宽度给出。
            </p>
          </div>
        </a-carousel>
      </a-col>
    </a-row>
    <div class="goods-list">
      <a-row type="flex" justify="center">
        <a-col
          :xs="24"
          :sm="8"
          class="goods-item"
          v-for="item in advList2"
          :key="item.id"
          @click="onLink(item.advertisingUrl)"
        >
          <img :src="imgUrl + item.advertisingImg" width="448" height="261" />
          <div class="desc">
            <span class="title">{{ item.advertisingTitle }}</span>
            <span class="detail">{{ item.content }}</span>
          </div>
        </a-col>
      </a-row>
    </div>
    <a-row class="decor">
      <div class="decor-content">
        <div class="content-box">
          <div class="title">花色系列</div>
          <div class="content">
            <div type="flex" v-for="(item, index) in decorList" :key="index">
              <span
                v-for="(subitem, index) in item"
                :key="index"
                class="content-text"
                @click="onSeries(subitem.value)"
                >{{ subitem.title }}</span
              >
            </div>
          </div>
          <div class="buttom" @click="onSeries(null)">花色总览</div>
        </div>
      </div>
    </a-row>
    <a-row class="news">
      <a-col :span="24">
        <div class="news-title"><span>新闻动态</span></div>
      </a-col>
      <div class="news-list">
        <div class="news-item" @click="onNewsDetails(item.id)" v-for="item in newsList" :key="item.id">
          <div class="title">
            <ellipsis :length="30" tooltip>·{{ item.name }}</ellipsis>
          </div>
          <div class="content">
            <ellipsis :length="150"> {{ item.content.replace(/<\/?.+?>/g, '').replace('&nbsp;', '') }}</ellipsis>
          </div>
        </div>
      </div>
    </a-row>
    <video-popup ref="dialog" src="http://static.vigour.net.cn/VIDEO.mp4" />
  </div>
</template>
<script>
import { Play } from '@icon-park/vue'
import Ellipsis from '@/components/Ellipsis'
import Banner from '@/components/Banner'
import VideoPopup from '@/components/VideoPopup'
import { getDictByCode, geAdvertisingList, getNewsList } from '@/api'
export default {
  components: {
    Banner,
    Play,
    VideoPopup,
    Ellipsis,
  },
  data() {
    return {
      carousel: 0,
      imgUrl: process.env.VUE_APP_IMG_URL,
      decorList: [],
      advList: [],
      showDialog: false,
      newsList: [],
    }
  },
  created() {
    this.init()
  },
  mounted() {
    console.log('>>>>', this.advList3)
  },
  computed: {
    advList2() {
      return this.advList.filter((item) => item.type === '2')
    },
    advList3() {
      return this.advList.filter((item) => item.type === '3')
    },
  },
  methods: {
    init() {
      getDictByCode('flower_type').then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i += 3) {
            this.decorList.push(res.result.slice(i, i + 3))
          }
        }
      })
      this.getadvData()
      this.getNewsData()
    },
    onLink(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    getNewsData() {
      getNewsList({ ...this.page }).then((res) => {
        if (res.success) {
          this.newsList = res.result.records.slice(0, 2)
        }
      })
    },
    getadvData() {
      geAdvertisingList({ type: '2,3' }).then((res) => {
        if (res.success) {
          this.advList = res.result
        }
      })
    },
    onNewsDetails(id) {
      const link = this.$router.resolve({ path: '/main/newsdetails', query: { id } })
      window.open(link.href, '_blank')
    },
    onSeries(type) {
      const link = this.$router.resolve({ path: '/main/series', query: type ? { type } : {} })
      window.open(link.href, '_blank')
    },
    onDialogShow() {
      this.$refs.dialog.isShow = true
    },
    carouselChange(a, b) {
      this.carousel = b
    },
  },
}
</script>
<style lang="stylus" scoped>
@import './index'
route()
.content
  .adv
    img
      margin 0 auto
  .nav
    width 100%
    padding 30px 0
    background-color #1f1f1f
    .control
      line-height 1
      margin 0 auto
      max-width 240px
      .title
        font-size 26px
        color #efefef
      .play
        cursor pointer
        &:hover
          opacity 0.5
  .split
    height 8px
    width 100%
    transform rotate(180deg)
    background-image url('~@/assets/images/split_bottom.jpg')
    background-repeat repeat-x
  .text-carousel
    .title
      margin-top 66px
      &::after
        display table
        content ''
        height 1px
        width 1048px
        background-color rgba(0, 0, 0, 0.2)
        margin 0 auto
      .text
        font-size 28px
        display flex
        justify-content center
        margin-bottom 46px
        li
          padding 0 28px
        .active
          // cursor pointer
          color #000
    .carousel
      width 909px
      margin 33px auto 40px auto
      p
        text-indent 0
        line-height 1.5
      .text
        margin-bottom 33px
        font-size 16px
        line-height 24px
    .ant-carousel
      >>> .slick-slide
        text-align center
        // max-height 650px
        overflow hidden
      >>> .slick-slide img
        display inline-block
        width 100%
        text-align center
        color #fff
      >>>.slick-dots
        button
          background #000 !important
          width 11px
          height 11px
          border-radius 50%
  .goods-list
    max-width 1350px
    margin 0 auto
    .goods-item
      position relative
      width 440px
      margin 0 5px 10px 5px
      overflow hidden
      &::after
        content ''
        display block
        position absolute
        top 0
        left 0
        width 440px
        height 100%
        background-color rgba(0, 0, 0, 0.6)
        visibility hidden
        cursor pointer
      &:hover::after
        visibility visible
      &:hover .desc
        transform translate(0, 0)
        opacity 1
      &:hover > img
        transform scale(1.5)
      .desc
        position absolute
        top 20px
        left 20px
        margin-right 15px
        color #fff
        text-align left
        line-height 2
        z-index 10
        transform translate(0, -30px)
        opacity 0
        transition all 0.5s ease
        > span
          display block
          cursor pointer
        .title
          font-size 18px
          font-weight bold
        .detail
          font-size 14px
      > img
        width 440px
        transition all 0.5s
  .decor
    width 100%
    height 435px
    background #f2f2f2
    margin-top 70px
    .decor-content
      padding-top 45px
      max-width 1300px
      margin 0 auto
      display flex
      justify-content center
      .content-box
        width 100%
        height 400px
        background-image url('~@/assets/images/cleaf_decor.png')
        background-repeat no-repeat
        background-size 1118px
        background-position right
        .title
          font-size 28px
          font-weight bold
          line-height 36px
          color #666
          text-align left
        .content
          padding 30px 0
          color #666
          line-height 36px
          text-align left
          font-size 18px
          .content-text
            display inline-block
            padding 0 12px 0 0
            &::after
              content ''
              display inline-block
              margin-left 12px
              background-color #666
              width 1px
              height 16px
            &:last-child
              &::after
                display none
            &:hover
              cursor pointer
              color #cc0200
        .buttom
          text-align center
          width 127px
          height 40px
          line-height 40px
          color #fff
          font-size 18px
          background #666
          &:hover
            cursor pointer
  .news
    margin-top 68px
    margin-bottom 66px
    .news-title
      border-top 1px #cccccc solid
      font-size 28px
      font-weight bold
      width 1300px
      margin 0 auto
      text-align left
      span
        display inline-block
        border-top 3px #666 solid
        padding-top 21px
    .news-list
      width 1290px
      margin 0 auto
      .news-item
        padding-top 38px
        width 550px
        float left
        text-align left
        &:hover
          cursor pointer
        &:last-child
          float right
        .title
          margin-bottom 18px
          font-size 24px
          line-height 30px
          letter-spacing 1px
          color #000
        .content
          font-size 16px
          color #666
          padding-left 24px
</style>
